export default "__VITE_ASSET__B183SSTk__"